import type { Plan } from './entitlements.js';

export interface BillingPlanDefinition {
  plan: Plan;
  name: string;
  price: string;
  interval: 'month';
  description: string;
  features: string[];
  featured?: boolean;
}

/** Marketing and display copy for the plan cards. Enforcement lives in PLAN_DEFAULTS. */
export const BILLING_PLAN_DEFINITIONS: BillingPlanDefinition[] = [
  {
    plan: 'free',
    name: 'Free',
    price: '$0',
    interval: 'month',
    description: 'For firms that want to see early projects before paying a cent.',
    features: ['Real-time projects', 'Scoring', '30 days of signal history', '1 user'],
  },
  {
    plan: 'starter',
    name: 'Starter',
    price: '$349',
    interval: 'month',
    description: 'For the BD person ready to stop missing early projects in their markets.',
    features: [
      'Everything in Free',
      'Full signal history',
      'Personalized real-time email alerts',
      'Up to 3 users',
    ],
    featured: true,
  },
  {
    plan: 'pro',
    name: 'Pro',
    price: '$1,299',
    interval: 'month',
    description: 'For firms running business development across markets and people.',
    features: [
      'Everything in Starter',
      'Microsoft Teams & Slack alerts',
      'API access',
      'Up to 10 users',
      'Additional seats available',
    ],
  },
];
